import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import CuentaPantallas from "@/components/CuentaPantallas";
import VictoriasEnLaNube from "@/components/VictoriasEnLaNube";
import AlPrincipio from "@/components/AlPrincipio";
import { AnimatePresence } from "framer-motion";
import "@/index.css";
import { AuthProvider } from "@/context/AuthContext";
import { AlphaOSProvider } from "@/context/AlphaOSContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Entrar from "@/pages/Entrar";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Celebraciones from "@/components/Celebraciones";
import CartelesDelMundo from "@/components/CartelesDelMundo";
// LAS CINCUENTA PANTALLAS VIVEN EN `paginas.js`, y no por orden: App.js estaba clavado en
// las 400 lineas del trinquete y la siguiente pantalla no cabia. Las declaraciones se mudan
// enteras con sus comentarios; aqui solo queda el arbol de rutas, que es de lo que habla
// este fichero. El porque de cada carga diferida, en la cabecera de `paginas.js`.
import {
  Agora, Dashboard, AlphaLab, MisMateriales, Familia, Academia, Metodologia, Cursos,
  CursoDetail, MisRecuerdos, Lecturas, Observatorio, Ajustes, TuMentor, Legal,
  TutorConfirma, InvitacionAcepta, Newsletter, NewsletterArticle, Contacto, BossBattle,
  JEFE_PRUEBA, JefePrueba, Test, Tests, Resultados, Precios, Login, Register, ClaveOlvidada, ClaveNueva, LessonView, Aula,
  JourneyMap, Mundo, Laberinto, AvatarCreator, AdminCMS, CmsCourseEditor,
  JourneyEditor, CmsImport, Cofres, AdminAnalytics, AdminResources,
  ProfesorPanel, AdminCommunities, AdminCommunityDetail, CommunityDetail, FinDeAcceso,
  Vuelve, PermisosDeTutor, Pagar, FichaDeAlumno, FichaDeMiAlumno, Comunicados,
  CeremoniaDeNivel, ViajeAlOrigen, ElOjo, InformeSemanal
} from "@/paginas";
import ExamMode from "@/components/ExamMode";
import { RefTracker } from "@/components/RefTracker";
import { useLocation as useLocationForRedirect } from "react-router-dom";
import CustomCursor from "@/components/CustomCursor";
import RecoveryScreen from "@/components/RecoveryScreen";
import { SystemStatusProvider, useSystemStatus } from "@/context/SystemStatusContext";
// LA PANTALLA DE UNA DIRECCION QUE NO EXISTE, y va aqui y no en `paginas.js` a proposito:
// diferir la pagina que aparece cuando algo YA ha ido mal es pagar un viaje de red para
// decir que no hay nada, y dejarla en blanco otra vez si ese viaje falla. Pesa dos kilos.
import NoEncontrada from "@/pages/NoEncontrada";
import AdminRoute from "@/components/AdminRoute";
import AvisoDePlan from "@/components/AvisoDePlan";
import { Toaster } from "sonner";
// Sin esto, una pantalla que revienta —o un trozo que no llega tras publicar— deja la web en blanco.
import TrozoQueNoLlega from "@/components/TrozoQueNoLlega";

// EL MENTOR FLOTANTE LLEGA UN MOMENTO DESPUÉS, y no se nota: es un botón en una esquina. Iba en
// la primera carga, que estaba a menos de un kilobyte del límite (roadmap móvil, fase 1).
const AlphaAssistant = lazy(() => import("@/components/AlphaAssistant"));

// Mientras el trozo de una pagina viaja por la red. Deliberadamente sobrio: un
// esqueleto elaborado se ve MAS que la espera que intenta disimular.
function Cargando() {
  return (
    <div className="min-h-[60vh] dvh:min-h-[60svh] flex items-center justify-center" role="status" aria-live="polite">
      <span className="sr-only">Cargando…</span>
      <span className="w-2 h-2 rounded-full bg-alpha-black/40 animate-pulse" />
    </div>
  );
}

function AppShell() {
  const { isDown } = useSystemStatus();

  if (isDown) {
    return <RecoveryScreen />;
  }

  return (
    <AuthProvider>
      <AlphaOSProvider>
      <BrowserRouter>
        <Navbar />
          {/* Debajo de la barra y encima de todo lo demas: el aviso de que el plan se acaba
              tiene que verse en la pantalla en la que este el alumno, no solo en el panel.
              Se pinta solo cuando quedan siete dias o menos. */}
          <AvisoDePlan />
          <RefTracker />
          {/* Cuenta que pantallas se abren y cuales no. No pinta nada, y va aqui -dentro del
              router y fuera de las rutas- porque es el unico sitio desde el que se ven todos
              los cambios de direccion. */}
          <CuentaPantallas />
          {/* Y sube lo ganado en los minijuegos: el porqué, en el propio componente. */}
          <VictoriasEnLaNube />
          {/* Las dos celebraciones —la de la misión y la de terminar algo largo—, montadas
              aquí y no en cada pantalla, y diferidas. El porqué de las dos cosas, en el
              fichero: dentro del router y fuera de las rutas, como `RefTracker`. */}
          <Celebraciones />
          {/* Y las vidas mientras Omega te persigue, por lo mismo: el mundo 3D avisa por un
              evento y esto lo pinta. `Mundo.jsx` no se entera de que existe. */}
          {/* Y el minijuego de la osa: el cartel que lo ofrece al acercarte a la cría, la
              pregunta mientras corres y cómo acabó. Mismo trato que las vidas —el mundo avisa
              por un evento, esto lo pinta— y además el camino de vuelta: los botones mandan al
              mundo por `MANDO`, sin variables globales de por medio. */}
          {/* EL DEL ÁRBOL DE LAS LENGUAS, y va aquí por lo mismo que el de arriba: el juego vive
              dentro del mundo 3D y el mundo 3D se desmonta al cambiar de pantalla, así que su
              cartel no puede vivir allí. Son dos y no estorban: cada uno escucha SU evento, y
              con un solo canal empezar una partida bajo el árbol abriría también el del ruedo. */}
          <CartelesDelMundo />
        <AlPrincipio />
        {/* LA CEREMONIA DE SUBIR DE NIVEL, y va aquí por lo mismo que `AlPrincipio`: la regla
            «celebra cuando subas» se cumple en un sitio, no en cincuenta pantallas acordándose.
            Ya se intentó sin querer —montada sólo en la del Jefe— y se cumplía en uno de los
            cuatro caminos que suben de nivel. Aquí escucha el parte que recoge el interceptor
            de `lib/api/client.js`, por donde pasan todas las respuestas de la casa, así que
            celebra también el quinto camino, el que nadie ha escrito todavía. */}
        <Suspense fallback={null}><CeremoniaDeNivel /></Suspense>
        <AnimatePresence mode="wait">
          <TrozoQueNoLlega>
          <Suspense fallback={<Cargando />}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/alpha" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/lab" element={<AlphaLab />} />
            <Route path="/laberinto" element={<ProtectedRoute><Laberinto /></ProtectedRoute>} />
            <Route path="/ojo" element={<ProtectedRoute><ElOjo /></ProtectedRoute>} />
            <Route path="/insignia" element={<ProtectedRoute><ViajeAlOrigen /></ProtectedRoute>} />
            <Route path="/mis-materiales" element={<ProtectedRoute><MisMateriales /></ProtectedRoute>} />
            <Route path="/familia" element={<ProtectedRoute><Familia /></ProtectedRoute>} />
            <Route path="/mundo" element={<Agora />} />
            {/* El codigo de clase. Con el en la direccion, el QR de la pizarra entra solo;
                sin el, la misma pagina lo pide, que es lo que hace falta en octubre. */}
            <Route path="/entrar" element={<ProtectedRoute><Entrar /></ProtectedRoute>} />
            <Route path="/entrar/:codigo" element={<ProtectedRoute><Entrar /></ProtectedRoute>} />
            {/* EL MUNDO PIDE SESIÓN, y hasta el 8 de septiembre de 2026 no la pedía. No era una
                decisión: era la única pareja de rutas de esta lista sin `ProtectedRoute` y sin
                una línea que dijera por qué. Se veía escribiendo la dirección.
                No hubo fuga —el servidor corta por su cuenta y devuelve 403 a la cuenta parada,
                así que allí dentro no se trataba ningún dato—, pero sí se saltaba lo que
                `ProtectedRoute` hace ADEMÁS de autenticar: la puerta de la edad, el permiso del
                tutor de un menor de catorce y el cambio de la contraseña impresa. Un alumno con
                la cuenta parada entraba a un mundo donde nada le funcionaba, que es peor que una
                puerta cerrada: parece una avería en vez de un «te falta esto».
                Lo vigila `tools/check_rutas.py`, que ya no deja nacer una ruta abierta sin su
                razón escrita. */}
            <Route path="/templo" element={<ProtectedRoute><Mundo entradaEn="templo" /></ProtectedRoute>} />
            <Route path="/explanada" element={<ProtectedRoute><Mundo entradaEn="explanada" /></ProtectedRoute>} />
            {/* Y LA MISMA EXPLANADA PARA PROYECTAR EN CLASE, ésta sí abierta y a propósito.
                Nace el 8 de septiembre de 2026 con la evaluación del departamento TIC en marcha:
                mientras no esté aprobada, la plataforma no puede dar de alta a ningún alumno del
                centro, pero el profesor sí puede enseñarla en la pizarra. Sin cuentas no hay
                dato de ningún menor: se ve el sitio, se juega el minijuego de la osa y se lee lo
                publicado, que es exactamente lo que ya sirve el servidor sin sesión.
                Es la MISMA pantalla a propósito: una copia para proyectar se queda vieja. */}
            <Route path="/clase" element={<Mundo entradaEn="explanada" />} />
            {/* EL MODO AULA, y es la segunda pareja de rutas abiertas a propósito de esta
                lista —la primera es `/clase`, aquí arriba—. Nace del mismo trato con el
                departamento TIC del centro y lo lleva un paso más allá: allí el profesor
                ENSEÑA la plataforma en la pizarra; aquí los treinta alumnos ENTRAN, desde su
                móvil, con un código de seis caracteres y las lecciones que él haya abierto
                para esa hora.
                VA SIN `ProtectedRoute` PORQUE NO HAY NADA QUE PROTEGER: no hay cuenta, no hay
                correo, no hay contraseña y el servidor no guarda una sola línea de quien entra
                (`backend/app/modules/communities/sesion_aula.py`). Pedir sesión aquí sería
                pedir exactamente lo que el centro no deja crear todavía, o sea cerrar la
                puerta entera. La llave es el token de aula: dura lo que dure la clase, viaja
                sólo en la cabecera `X-Aula` y muere al cerrar la pestaña.
                Con el código en la dirección, el QR de la pizarra entra solo —igual que hace
                `/entrar/:codigo`—; sin él, la misma pantalla lo pide, que es lo que hace falta
                para el que llega tarde.
                Lo vigila `tools/check_puertas.py`, donde las dos están declaradas con su
                razón escrita. */}
            <Route path="/aula" element={<Aula />} />
            <Route path="/aula/:codigo" element={<Aula />} />
            <Route path="/profesor" element={<ProtectedRoute><ProfesorPanel /></ProtectedRoute>} />
            <Route path="/profesor/alumnos/:id" element={<ProtectedRoute><FichaDeMiAlumno /></ProtectedRoute>} />
            {/* LA HABITACION ALPHA SE RETIRO el 13 de octubre de 2026. La direccion se queda
                viva y lleva al panel: estaba en el menu de todos y en marcadores, y una pagina
                que no existe se lee como una averia. */}
            <Route path="/habitacion" element={<Navigate to="/alpha" replace />} />
            <Route path="/en-vivo" element={<HashRedirect to="/mundo" />} />
            <Route path="/agora" element={<HashRedirect to="/mundo" />} />
            <Route path="/origen" element={<Academia />} />
            <Route path="/origen/metodologia" element={<Metodologia />} />
            <Route path="/cursos" element={<Cursos />} />
            <Route path="/cursos/:slug" element={<CursoDetail />} />
            <Route path="/cursos/:slug/leccion/:lessonId" element={<LessonView />} />
            <Route path="/journey/:courseId" element={<JourneyMap />} />
            <Route
              path="/personaje"
              element={
                <ProtectedRoute>
                  <AvatarCreator />
                </ProtectedRoute>
              }
            />
            <Route path="/recuerdos" element={<MisRecuerdos />} />
            {/* La Biblioteca Viva recomienda libros (C8). Con sesion y no sin ella: se
                eligen con lo que el alumno marco en el test de intereses, y sin cuenta no
                hay con que elegir -saldrian siempre los mismos cuatro-. */}
            <Route path="/lecturas" element={<ProtectedRoute><Lecturas /></ProtectedRoute>} />
            {/* El Firmamento de la Memoria, que vivia dentro de /recuerdos. Tiene
                direccion propia porque se llega desde dos sitios: la puerta de Mis
                Recuerdos y el telescopio del Observatorio del Templo. */}
            <Route path="/observatorio" element={<ProtectedRoute><Observatorio /></ProtectedRoute>} />
            {/* Y YA NO HAY `/observatorio/trazado`, que se fue el 4 de octubre de 2026. Era
                un minijuego de unir parejas que NO ESCRIBIA EN NINGUN SITIO -ni victoria, ni
                aprendizaje, ni olvido apagado-, asi que el cielo seguia igual despues de
                jugarlo. Lo que el Observatorio abre ahora es el repaso de Mnemo, que es lo
                que consolida lo que ya has visto; el porque esta en `pages/Observatorio.jsx`.
                La pantalla se borra en vez de quedarse sin enlace: una pagina a la que no se
                llega es codigo que alguien tendra que mantener sin saber para que. */}
            {/* Los ajustes se pintan tambien SIN sesion: quien necesita mas contraste lo
                necesita antes de entrar, no despues. */}
            <Route path="/ajustes" element={<Ajustes />} />
            <Route path="/tu-mentor" element={<ProtectedRoute><TuMentor /></ProtectedRoute>} />
            <Route path="/legal/:doc" element={<Legal />} />
            {/* La abre el TUTOR desde su correo, y por eso NO va protegida: quien decide por
                un menor de catorce no tiene cuenta en la Academia ni tiene por que tenerla.
                Lo unico que autoriza es el token firmado del enlace. */}
            <Route path="/tutor" element={<TutorConfirma />} />
            {/* La abre quien ha sido INVITADO a un plan Familiar, desde su correo: sin proteger,
                porque se llega desde una bandeja de entrada. Es el acto que enlaza la cuenta. */}
            <Route path="/invitacion" element={<InvitacionAcepta />} />
            <Route path="/informe" element={<InformeSemanal />} />
            {/* Y esta la abre el ALUMNO del instituto desde el correo de las notas.
                Tampoco va protegida, por el motivo mas simple: todavia no tiene cuenta.
                No lleva el precio a proposito -el porque, en su propia cabecera- y mide
                el correo sin montar nada: `CuentaPantallas` la cuenta como a las demas. */}
            <Route path="/vuelve" element={<Vuelve />} />
            <Route path="/pagar" element={<Pagar />} />
            <Route path="/newsletter" element={<Newsletter />} />
            <Route path="/newsletter/:slug" element={<NewsletterArticle />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/boss/:courseId" element={<BossBattle />} />
            {JEFE_PRUEBA && <Route path="/finalboss" element={<ProtectedRoute><JefePrueba /></ProtectedRoute>} />}
            {JEFE_PRUEBA && <Route path="/finalboss/:courseId" element={<ProtectedRoute><BossBattle prueba /></ProtectedRoute>} />}
            {/* La pestaña «Tests»: los cuatro con su boton. `/test` en singular sigue
                siendo el de ruta, que es a donde apuntan los enlaces de toda la casa. */}
            <Route path="/tests" element={<Tests />} />
            <Route path="/test" element={<Test />} />
            {/* Los cuatro tests comparten componente: la clave dice cual es. `/test` a
                secas sigue siendo el de la ruta, que es el enlace que ya estaba por ahi. */}
            <Route path="/test/:clave" element={<Test />} />
            <Route path="/resultados/:id" element={<Resultados />} />
            {/* El dia despues del piloto. No es la pagina de precios: primero se le
                dice que no ha perdido nada, y solo despues lo que cuesta seguir. */}
            <Route path="/fin-de-acceso" element={<ProtectedRoute><FinDeAcceso /></ProtectedRoute>} />
            <Route path="/precios" element={<Precios />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            {/* «¿Has olvidado tu contraseña?»: sin sesión, porque quien llega aquí no puede entrar. */}
            <Route path="/clave-olvidada" element={<ClaveOlvidada />} />
            <Route path="/clave-nueva" element={<ClaveNueva />} />

            <Route
              path="/comunidad/:id"
              element={
                <ProtectedRoute>
                  <CommunityDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/cms"
              element={
                <AdminRoute>
                  <AdminCMS />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/analitica"
              element={
                <AdminRoute>
                  <AdminAnalytics />
                </AdminRoute>
              }
            />
            {/* Comunicados: el correo a todas las cuentas y los Directos. Solo admin. */}
            <Route
              path="/admin/comunicados"
              element={
                <AdminRoute>
                  <Comunicados />
                </AdminRoute>
              }
            />
            {/* La ficha de un alumno: nombre, correos, notas y dudas de un menor. Solo admin. */}
            <Route
              path="/admin/alumnos/:id"
              element={
                <AdminRoute>
                  <FichaDeAlumno />
                </AdminRoute>
              }
            />
            {/* Los permisos de tutor. Detras de `AdminRoute` y no de `ProtectedRoute`: la
                pantalla lleva el nombre de un menor al lado del correo de un adulto. */}
            <Route
              path="/admin/permisos"
              element={
                <AdminRoute>
                  <PermisosDeTutor />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/recursos"
              element={
                <AdminRoute>
                  <AdminResources />
                </AdminRoute>
              }
            />
            <Route
              path="/cofres"
              element={
                <ProtectedRoute>
                  <Cofres />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/cms/import"
              element={
                <AdminRoute>
                  <CmsImport />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/cms/journey/:mapId"
              element={
                <AdminRoute>
                  <JourneyEditor />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/cms/:id"
              element={
                <AdminRoute>
                  <CmsCourseEditor />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/comunidades"
              element={
                <AdminRoute>
                  <AdminCommunities />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/comunidades/:id"
              element={
                <AdminRoute>
                  <AdminCommunityDetail />
                </AdminRoute>
              }
            />
            {/* Y LA ULTIMA, QUE ES LA QUE NO HABIA: cualquier direccion que no sea ninguna
                de las de arriba. Hasta el 7 de octubre de 2026 esto no existia, asi que una
                direccion desconocida pintaba la barra, el pie y NADA EN MEDIO. Una pagina en
                blanco no dice «te has equivocado», dice «esto esta roto».
                Va sin `ProtectedRoute` por lo mismo que `/login`: quien se equivoca de
                direccion puede no haber entrado, y pedirle sesion para que le digan que la
                pagina no existe es cerrarle dos puertas de una. No lee nada del servidor.
                Declarada con su razon en `tools/check_puertas.py`. */}
            <Route path="*" element={<NoEncontrada />} />
          </Routes>
          </Suspense>
          </TrozoQueNoLlega>
        </AnimatePresence>
        <Footer />
        <Suspense fallback={null}><AlphaAssistant /></Suspense>
        <ExamMode />
        {/* Los avisos, por encima de la barra de inicio del iPhone (roadmap móvil, 1.5). */}
        <Toaster position="bottom-right" theme="light"
          mobileOffset={{ bottom: "calc(16px + env(safe-area-inset-bottom))" }} />
      </BrowserRouter>
      </AlphaOSProvider>
    </AuthProvider>
  );
}

// Redirección de rutas renombradas conservando el ancla Y la consulta. Son dos:
// /en-vivo → /mundo, por el `?cancel_token=` del correo de reserva, que vive en el buzón
// de quien reservó; y /agora → /mundo, por el `?ref=` que reparte el botón de compartir.
// Tirar la query era la mitad del defecto de R3.25: se perdía sin decir nada.
function HashRedirect({ to }) {
  const { hash, search } = useLocationForRedirect();
  return <Navigate to={{ pathname: to, hash, search }} replace />;
}

function App() {
  return (
    <div className="App min-h-screen min-h-svh bg-white text-alpha-black">
      <CustomCursor />
      <SystemStatusProvider>
        <AppShell />
      </SystemStatusProvider>
    </div>
  );
}

export default App;
